/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<circle
				opacity="0.4"
				cx="12"
				cy="12"
				r="3"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M2.5 9.5L3.97103 16.8552C4.33756 18.6879 4.52083 19.6042 4.99929 20.2896C5.42121 20.894 6.00194 21.3701 6.67737 21.6653C7.44332 22.0001 8.3778 22.0001 10.2467 22.0001H13.7533C15.6222 22.0001 16.5567 22.0001 17.3226 21.6653C17.9981 21.3701 18.5788 20.894 19.0007 20.2896C19.4792 19.6042 19.6624 18.6879 20.029 16.8552L21.5 9.5M1 11L7.47452 4.52548C9.05858 2.94142 9.85062 2.14938 10.7639 1.85263C11.5673 1.5916 12.4327 1.5916 13.2361 1.85263C14.1494 2.14938 14.9414 2.94142 16.5255 4.52548L23 11"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M21.5 9.5L20.029 16.8552C19.6624 18.6879 19.4792 19.6042 19.0007 20.2896C18.5788 20.894 17.9981 21.3701 17.3226 21.6653C16.5567 22.0001 15.6222 22.0001 13.7533 22.0001H10.2467C8.3778 22.0001 7.44332 22.0001 6.67737 21.6653C6.00194 21.3701 5.42121 20.894 4.99929 20.2896C4.52083 19.6042 4.33756 18.6879 3.97103 16.8552L2.5 9.5L7.47452 4.52548C9.05858 2.94142 9.85062 2.14938 10.7639 1.85263C11.5673 1.5916 12.4327 1.5916 13.2361 1.85263C14.1494 2.14938 14.9414 2.94142 16.5255 4.52548L21.5 9.5ZM12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
				fill="currentColor"
			/>
			<path
				d="M2.5 9.5L3.97103 16.8552C4.33756 18.6879 4.52083 19.6042 4.99929 20.2896C5.42121 20.894 6.00194 21.3701 6.67737 21.6653C7.44332 22.0001 8.3778 22.0001 10.2467 22.0001H13.7533C15.6222 22.0001 16.5567 22.0001 17.3226 21.6653C17.9981 21.3701 18.5788 20.894 19.0007 20.2896C19.4792 19.6042 19.6624 18.6879 20.029 16.8552L21.5 9.5M1 11L7.47452 4.52548C9.05858 2.94142 9.85062 2.14938 10.7639 1.85263C11.5673 1.5916 12.4327 1.5916 13.2361 1.85263C14.1494 2.14938 14.9414 2.94142 16.5255 4.52548L23 11M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M17.0558 3.99515L22.0221 8.96142C22.0273 8.96652 22.0325 8.9717 22.0376 8.97695L23.5303 10.4697C23.8232 10.7626 23.8232 11.2374 23.5303 11.5303C23.2374 11.8232 22.7626 11.8232 22.4697 11.5303L21.9606 11.0213L20.7644 17.0023L20.7587 17.031L20.7586 17.0311C20.5803 17.9231 20.4383 18.6331 20.2793 19.2038C20.1161 19.7898 19.9223 20.2797 19.6157 20.7189C19.1147 21.4367 18.4251 22.002 17.623 22.3525C17.1322 22.567 16.6138 22.6611 16.0072 22.7062C15.4163 22.7501 14.6922 22.7501 13.7825 22.7501H13.7533H10.2467H10.2175C9.30782 22.7501 8.58371 22.7501 7.99284 22.7062C7.38622 22.6611 6.86782 22.567 6.37703 22.3525C5.57495 22.002 4.88533 21.4367 4.3843 20.7189C4.07772 20.2797 3.88385 19.7898 3.72068 19.2038C3.56174 18.633 3.41974 17.923 3.24134 17.031L3.24134 17.031L3.2356 17.0023L2.0394 11.0213L1.53033 11.5303C1.23744 11.8232 0.762563 11.8232 0.46967 11.5303C0.176777 11.2374 0.176777 10.7626 0.46967 10.4697L1.9624 8.97694C1.96749 8.97169 1.97266 8.96652 1.97791 8.96143L6.94419 3.99515L6.96753 3.97181C7.73978 3.19955 8.35178 2.58754 8.88537 2.13456C9.43103 1.67133 9.94385 1.33049 10.5322 1.13933C11.4862 0.829359 12.5138 0.829359 13.4678 1.13933C14.0562 1.33049 14.569 1.67133 15.1146 2.13456C15.6482 2.58753 16.2602 3.19951 17.0324 3.97174L17.0325 3.97182L17.0558 3.99515ZM15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M2.5 9.5L3.97103 16.8552C4.33756 18.6879 4.52083 19.6042 4.99929 20.2896C5.42121 20.894 6.00194 21.3701 6.67737 21.6653C7.44332 22.0001 8.3778 22.0001 10.2467 22.0001H13.7533C15.6222 22.0001 16.5567 22.0001 17.3226 21.6653C17.9981 21.3701 18.5788 20.894 19.0007 20.2896C19.4792 19.6042 19.6624 18.6879 20.029 16.8552L21.5 9.5M12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12C15 11.6494 14.9398 11.3128 14.8293 11M1 11L7.47452 4.52548C9.05858 2.94142 9.85062 2.14938 10.7639 1.85263C11.5673 1.5916 12.4327 1.5916 13.2361 1.85263C14.1494 2.14938 14.9414 2.94142 16.5255 4.52548L23 11"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M2.5 9.5L3.97103 16.8552C4.33756 18.6879 4.52083 19.6042 4.99929 20.2896C5.42121 20.894 6.00194 21.3701 6.67737 21.6653C7.44332 22.0001 8.3778 22.0001 10.2467 22.0001H13.7533C15.6222 22.0001 16.5567 22.0001 17.3226 21.6653C17.9981 21.3701 18.5788 20.894 19.0007 20.2896C19.4792 19.6042 19.6624 18.6879 20.029 16.8552L21.5 9.5M1 11L7.47452 4.52548C9.05858 2.94142 9.85062 2.14938 10.7639 1.85263C11.5673 1.5916 12.4327 1.5916 13.2361 1.85263C14.1494 2.14938 14.9414 2.94142 16.5255 4.52548L23 11M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M17.0558 3.99515L22.0221 8.96142C22.0273 8.96652 22.0325 8.9717 22.0376 8.97695L23.5303 10.4697C23.8232 10.7626 23.8232 11.2374 23.5303 11.5303C23.2374 11.8232 22.7626 11.8232 22.4697 11.5303L21.9606 11.0213L20.7644 17.0023L20.7587 17.031L20.7586 17.0311C20.5803 17.9231 20.4383 18.6331 20.2793 19.2038C20.1161 19.7898 19.9223 20.2797 19.6157 20.7189C19.1147 21.4367 18.4251 22.002 17.623 22.3525C17.1322 22.567 16.6138 22.6611 16.0072 22.7062C15.4163 22.7501 14.6922 22.7501 13.7825 22.7501H13.7533H10.2467H10.2175C9.30782 22.7501 8.58371 22.7501 7.99284 22.7062C7.38622 22.6611 6.86782 22.567 6.37703 22.3525C5.57495 22.002 4.88533 21.4367 4.3843 20.7189C4.07772 20.2797 3.88385 19.7898 3.72068 19.2038C3.56174 18.633 3.41974 17.923 3.24134 17.031L3.24134 17.031L3.2356 17.0023L2.0394 11.0213L1.53033 11.5303C1.23744 11.8232 0.762563 11.8232 0.46967 11.5303C0.176777 11.2374 0.176777 10.7626 0.46967 10.4697L1.9624 8.97694C1.96749 8.97169 1.97266 8.96652 1.97791 8.96143L6.94419 3.99515L6.96753 3.97181C7.73978 3.19955 8.35178 2.58755 8.88537 2.13456C9.43103 1.67133 9.94385 1.33049 10.5322 1.13933C11.4862 0.829359 12.5138 0.829359 13.4678 1.13933C14.0562 1.33049 14.569 1.67133 15.1146 2.13456C15.6482 2.58753 16.2602 3.1995 17.0324 3.97173L17.0325 3.97182L17.0558 3.99515Z"
				fill="currentColor"
			/>
			<path
				d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
